/**
 * Push an event to the Google Tag Manager dataLayer.
 *
 * `window.dataLayer` is initialized in `public/index.html`, but we still guard
 * against SSR and any environment where the array might not exist yet.
 *
 * @param {string} event - The GTM event name (e.g. "free_consult_enter").
 * @param {Object} [payload] - Additional fields to merge into the event object.
 */
export const pushDataLayerEvent = (event, payload = {}) => {
  if (typeof window === 'undefined') return;
  if (!event) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...payload });
};
